// Deep-link helper: /orders/by-external/IDM… resolves the MBO order ID to
// the internal UUID and forwards to the order page. Used by AI chat links.

import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { aiChatApi } from '../api/services';
import { Loader2 } from 'lucide-react';

export default function OrderByExternal() {
  const { ext } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    aiChatApi.resolveOrder(ext)
      .then((r) => navigate(`/orders/${r.data.id}`, { replace: true }))
      .catch(() => setError(`No order found for ${ext}`));
  }, [ext, navigate]);

  return (
    <div className="p-12 text-center text-sm text-gray-500">
      {error || <><Loader2 className="w-4 h-4 animate-spin inline mr-2" /> Opening {ext}…</>}
    </div>
  );
}
